import { render, staticRenderFns } from "./tableGrid.vue?vue&type=template&id=828ca84c&scoped=true&"
import script from "./tableGrid.vue?vue&type=script&lang=js&"
export * from "./tableGrid.vue?vue&type=script&lang=js&"
import style0 from "./tableGrid.vue?vue&type=style&index=0&id=828ca84c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828ca84c",
  null
  
)

export default component.exports